// Purchasable packages. `key` MUST match a Stripe lookup_key created by
// backend/setup_stripe.py. Prices are display-only — the real, tamper-proof
// amount is fixed server-side in Stripe.
export const STRIPE_PACKAGES = [
  { key: "rev_audit", name: "Revenue Audit", price: "$497", group: "revenue", blurb: "Full revenue-path diagnostic." },
  { key: "rev_lead_capture", name: "Lead Capture System", price: "$2,000", group: "revenue", blurb: "Capture and route every inquiry." },
  { key: "rev_follow_up", name: "Follow-Up + Booking System", price: "$4,250", group: "revenue", blurb: "Automated follow-up and booking." },
  { key: "rev_revenue_conversion", name: "Revenue Conversion System", price: "$10,000", group: "revenue", blurb: "End-to-end conversion engine." },
  { key: "web_starter", name: "Starter Website", price: "$1,500", group: "website", blurb: "One-page conversion site." },
  { key: "web_growth", name: "Growth Website", price: "$2,500", group: "website", blurb: "Multi-page business site." },
  { key: "web_premium", name: "Premium Website", price: "$3,500", group: "website", blurb: "Premium build with booking." },
  {
    key: "retainer_monthly",
    name: "Retainer",
    price: "$250",
    period: "/mo",
    group: "retainer",
    recurring: true,
    blurb: "Ongoing care so your system keeps compounding.",
    features: [
      "Ongoing website updates, maintenance & performance optimization",
      "Local SEO monitoring & continuous search-visibility improvements",
      "Monthly analytics report with actionable growth recommendations",
      "Priority support for content, design & automation adjustments",
    ],
  },
];
